<template>
  <v-card id="card-modal" class="py-4 elevation-4">
    <v-card-title class="justify-center">
      <div>
        <h3 class="primary--text">
          {{ $t("components.views.trip.no_offer_assign.modal_create_trailer.new_trailer") }}
        </h3>
      </div>
      <v-btn depressed text color="primary" class="cont" @click="closeModal()">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider class="mt-2 mb-3 mx-10 secondary" />
    <v-card-text>
      <v-form v-model="valid">
        <v-container fluid>
          <v-row class="justify-center">
            <v-col cols="10" class="pb-0">
              <v-text-field
                v-model="id"
                required
                disabled
                dense
                outlined
                hide-details
                :label="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.license_plate')
                "
                :placeholder="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.license_plate')
                "
                :rules="[
                  required(
                    $t('components.views.trip.no_offer_assign.modal_create_trailer.license_plate'),
                    0
                  ),
                ]"
                prepend-icon="fa-solid fa-trailer"
              />
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="10" class="pb-0">
              <v-text-field
                v-model="trailerTypeDisplay"
                required
                disabled
                dense
                outlined
                hide-details
                :label="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.typeVehicle')
                "
                :placeholder="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.typeVehicle')
                "
                prepend-icon="fa-solid fa-trailer"
              />
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="10" class="pb-0">
              <SelectAutocomplete
                ref="vehicleFleetType"
                v-model="trailerNew.fleetType"
                :url="urlVehicleFleetType"
                return-object
                dense
                item-text="name"
                maxlength="10"
                item-value="idMaster"
                prepend-icon="fa-solid fa-arrow-up"
                :label="$t('components.views.trip.no_offer_assign.modal_create_trailer.fleetType')"
                required
                :placeholder="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.fleetType')
                "
                :rules="[
                  required(
                    $t('components.views.trip.no_offer_assign.modal_create_trailer.fleetType'),
                    1
                  ),
                ]"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="10" class="pb-0">
              <SelectAutocomplete
                ref="vehicleTypology"
                v-model="trailerNew.typology"
                :url="urlVehicleTypology"
                return-object
                dense
                item-text="name"
                maxlength="10"
                item-value="idVehicleTypology"
                prepend-icon="fa-solid fa-minus"
                :label="$t('components.views.trip.no_offer_assign.modal_create_trailer.typology')"
                required
                :placeholder="
                  $t('components.views.trip.no_offer_assign.modal_create_trailer.typology')
                "
                :rules="[
                  required(
                    $t('components.views.trip.no_offer_assign.modal_create_trailer.typology'),
                    1
                  ),
                ]"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row class="justify-center mt-6">
            <v-btn color="secondary" :disabled="active || !valid" @click="newTrailer()" depressed>
              <v-icon small class="fa-solid fa-bookmark mr-1" />
              {{ $t("components.views.trip.no_offer_assign.modal_create_trailer.save") }}
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import validate from "@/plugins/validate";

export default {
  props: {
    idLicensePlate: {
      type: String,
      default: "",
    },
    idCompany: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      valid: false,
      ...validate,
      active: false,
      trailerNew: {
        typeVehicle: { idVehicleClass: 15, name: "Trailer" },
        fleetType: "",
        typology: "",
        id: "",
      },
    };
  },
  computed: {
    id() {
      return this.idLicensePlate;
    },
    urlVehicleClassList() {
      return `/Vehicles/vehicleClassList`;
    },
    urlVehicleFleetType() {
      return `/Vehicles/vehicleFleetList`;
    },
    urlVehicleTypology() {
      return `/Vehicles/vehicleTypologyList`;
    },
    trailerTypeDisplay() {
      return "Remolque";
    },
  },
  mounted() {
    this.resetFields();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    resetFields() {
      this.$nextTick(() => {
        this.trailerNew = Object.assign(
          {},
          {
            typeVehicle: { idVehicleClass: 15, name: "Trailer" },
            fleetType: "",
            typology: "",
            id: "",
          }
        );
      });
    },

    closeModal() {
      this.resetFields();
      this.$emit("closeForm");
    },

    async newTrailer() {
      this.active = true;

      this.trailerNew.id = this.id;

      const user = JSON.parse(store.getters["auth/user"]);

      let trailer = {
        licensePlate: this.id,
        idVehicleClass: this.trailerNew.typeVehicle.idVehicleClass,
        idMasterFleet: this.trailerNew.fleetType.idMaster,
        idCompany: this.idCompany,
        idVehicleTypology: this.trailerNew.typology.idVehicleTypology,
      };

      await this.axios
        .post("/Vehicles/Create/", trailer)
        .then(() => {
          this.showSnack({
            text: this.$t(
              "components.views.trip.no_offer_assign.modal_create_trailer.trailer_created_success"
            ),
            title: this.$t("components.views.trip.no_offer_assign.modal_create_trailer.success"),
            name: "success",
          });

          //Envio al Edit el trailer creado
          this.$emit("trailerCreated", this.trailerNew.id);

          //Reset al Botón de Guardar
          this.active = false;

          this.closeModal();
        })
        .catch((error) => {
          this.closeModal();
          this.showSnack({
            text: error.response.data,
            title: this.$t(
              "components.views.trip.no_offer_assign.modal_create_trailer.trailer_created_error"
            ),
            name: "error",
          });
          this.active = false;
        });
    },
  },
};
</script>

<style scoped>
#card-modal {
  border: 3px solid #0b0045 !important;
}

.v-divider {
  border-width: 1px !important;
}

#card-modal p {
  font-size: 1.17em !important;
}

.cont {
  position: absolute;
  right: 10px;
}
</style>